export const API_HOST = import.meta.env.VITE_API_HOST;
export const BASE_LAMBDA_ENDPOINT = import.meta.env.VITE_BASE_LAMBDA_ENDPOINT;
export const ID_SERVICE = import.meta.env.VITE_ID_SERVICE;
export const LEVEL = import.meta.env.VITE_LEVEL || 'development';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const MOCK_JWT = import.meta.env.VITE_MOCK_JWT;
export const AUTH_COOKIE_NAME = import.meta.env.VITE_AUTH_COOKIE_NAME;
export const PHONE_APP_AUTH_TOKEN = import.meta.env.VITE_PHONE_APP_AUTH_TOKEN;
export const SHOW_UPCOMING_FEATURES = import.meta.env.VITE_SHOW_UPCOMING_FEATURES === 'true';
export const CENTRIFUGO_URL = import.meta.env.VITE_CENTRIFUGO_URL;
export const TWILIO_SIGNALING_ENDPOINT = import.meta.env.VITE_TWILIO_SIGNALING_ENDPOINT;
export const YELP_INTEGRATION_URL = import.meta.env.VITE_YELP_INTEGRATION_URL;
